import React from 'react'

export default function ProjectEmbed(props) {
    return (
        <div className='project-embed'>
            <div className='banner'>
                COWBOY BEBOP MOTION GRAPHIC
            </div>
            <div className='box-4'>
                <iframe width="100%" height="100%" src={props.link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div className='box-3'>
                Softwares Used: AE <br />  <br />
                This project was to create a motion graphics style video to a mainly instrumental song. Being an anime fan, the opening to Cowboy Bebop was an instant choice for me. I used similar color themes from the original video but decided to go more with the jazz and instrumental visuals rather than objects from the show itself. This was storyboarded on pen and paper before animating straight through in After Effects.
            </div>
        </div>
    )
}
